<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          あなたのWebページ内にあるリンクはすべて正常に動いています。
        </p>
        <p v-else>
          あなたのWebページ内にあるリンクの中で一部問題があります。
        </p>
      </div>
    </li>
    <li v-if="brokenLinkAbnormalLinks.length" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <dl>
          <dt>異常なリンク</dt>
          <dd>
            <ul class="c-list--disc">
              <li v-for="(item, index) in brokenLinkAbnormalLinks" :key="index">
                {{ item.url }}
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <ul class="c-list--disc">
          <li v-for="(item, index) in brokenLinkAbnormalLinks" :key="index">
            {{ item.url }}
          </li>
        </ul>
        <ol class="c-list--decimal">
          <li>異常なリンクを上記にて確認をする。</li>
          <li>
            エラー対象のリンクをコピーする。<br />
            例）href='https://www.example.co.jp/hogehoge?code=fojasdoifjaowijoijdo$%jkda'<br />
            example.co.jp/hogehogeをコピーして検索を行う。<br />
            注）？以降はランダム値である可能性及び、インターネット越しにアクセスした場合に付与される可能性があるため
          </li>
          <li>HPのソース（HTML)から該当箇所を確認し、修正を行う。</li>
        </ol>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    brokenLinkAbnormalLinks() {
      if (this.detail.link.abnormals) {
        return this.detail.link.abnormals.filter(item => item.url);
      }
      return [];
    }
  }
};
</script>
